"use client";

import { Menu } from "lucide-react";

import styles from "./CategoryFilters.module.css";

export default function CategoryFiltersMenuButton({
  onClick,
}: {
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className={styles.menuButton}
      aria-label="Menu"
      onClick={onClick}
    >
      <Menu size={18} />
    </button>
  );
}
